export const productTypesAPI = {
    async getProductTypes() {
        let resp = await fetch("/api/product-types").catch((err) => {
            console.log(err);
        })

        let error = null
        let body = await resp
            .json()
            .catch(e => error = "something_went_wrong");

        if(error) {
            return {
                ok: false,
                err: error
            }
        }
        
        if(!body) {
            return {
                ok: false, 
                err: "something_went_wrong"
            };
        }

        if(!body.ok) {
            return {
                ok: false,
                err: "something_went_wrong"
            }
        }

        return {
            ok: true,
            productTypes: body["product-types"]
        }
    }, 
}